import { createAction } from '@reduxjs/toolkit';

import { OrderDetailsFormOutput } from '../../../modules/orderDetails/schemas.ts';

export const submitEditOrderDetailsForm = createAction<OrderDetailsFormOutput  & { id: string }>(
  'submitEditOrderDetailsForm',
);
